import {
  Edit,
  ListButton,
  number,
  NumberInput,
  required,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const TrafficSourceEdit = () => (
  <Edit actions={<EditActions />} mutationMode="pessimistic">
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput
        source="title"
        helperText="example: Facebook"
        validate={required()}
      />
      <NumberInput
        label="max Click ID Length"
        source="maxClickIdLength"
        validate={[number(), required()]}
      />
      <TextInput label="Created At" source="createdAt" disabled />
      <TextInput label="Updated At" source="updatedAt" disabled />
    </SimpleForm>
  </Edit>
);
